import React from "react";

/** Évite l'écran blanc : affiche l'erreur et un bouton de rechargement, et la journalise dans la console. */
export class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("[DOJOVA] erreur d'affichage", error, info?.componentStack); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6" data-testid="error-boundary">
        <div className="max-w-lg rounded-2xl border border-red-500/40 bg-red-500/5 p-6 space-y-3 text-zinc-100">
          <div className="text-lg font-black">Cette page a rencontré une erreur d'affichage</div>
          <pre className="text-xs text-red-200 whitespace-pre-wrap max-h-40 overflow-auto" data-testid="error-boundary-message">{String(this.state.error?.message || this.state.error)}</pre>
          <div className="flex gap-2">
            <button type="button" onClick={() => window.location.reload()} className="rounded-full bg-amber-500 text-zinc-950 font-bold px-4 py-2 text-sm" data-testid="error-boundary-reload">Recharger</button>
            <a href="/app" className="rounded-full border border-zinc-700 px-4 py-2 text-sm text-zinc-200">Retour à l'accueil</a>
          </div>
        </div>
      </div>
    );
  }
}
